import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import ActionDelete from '@mui/icons-material/Delete';
import clsx from 'clsx';
import {
    useTranslate,
    RaRecord,
    RedirectionSideEffect,
    useDeleteWithUndoController,
    useRecordContext,
    useResourceContext,
} from 'react-admin';

export const DeleteWithUndoIconButton = (
    props: DeleteWithUndoIconButtonProps
) => {
    const {
        className,
        label = 'ra.action.delete',
        redirect: redirectTo = 'list',
    } = props;
    const record = useRecordContext(props);
    const resource = useResourceContext(props);
    const { isLoading, handleDelete } = useDeleteWithUndoController({
        resource,
        record,
        redirect: redirectTo,
    });
    const translate = useTranslate();
    const translatedLabel = translate(label, { _: label });
    return (
        <Tooltip title={translatedLabel}>
            <IconButton
                aria-label={translatedLabel}
                disabled={isLoading}
                onClick={handleDelete}
                className={clsx('ra-delete-button', className)}
                key="button"
                size="small"
            >
                <ActionDelete color="error" />
            </IconButton>
        </Tooltip>
    );
};

export type DeleteWithUndoIconButtonProps = {
    className?: string;
    confirmTitle?: string;
    confirmContent?: string;
    icon?: ReactElement;
    label?: string;
    onClick?: (e: MouseEvent) => void;
    record?: RaRecord;
    redirect?: RedirectionSideEffect;
    resource?: string;
    invalid?: boolean;
    pristine?: boolean;
    saving?: boolean;
    submitOnEnter?: boolean;
};

DeleteWithUndoIconButton.propTypes = {
    className: PropTypes.string,
    confirmTitle: PropTypes.string,
    confirmContent: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.any,
    redirect: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.func,
    ]),
    resource: PropTypes.string,
    icon: PropTypes.element,
};
